import { memo } from 'react';
import { Text, Menu, Button, MenuList, MenuItem, MenuButton } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';
import InterText from 'shared/InterText';

import { DEFAULT_TRANSITION, EMPTY_OBJECT } from 'constants/global';
import DownAngle from 'assets/icons/downAngle.svg';
import { masks } from './model/masks';

const CountrySelector = ({ activeMask, onMaskChange }) => (
  <Menu flip={false} isLazy gutter={2}>
    <MenuButton
      as={Button}
      role="group"
      w="fit-content"
      h="full"
      gap={{ laptop: '10px' }}
      bgColor="ourWhite"
      borderRadius="none"
      borderTopLeftRadius="full"
      borderBottomLeftRadius="full"
      p={{ mobile: '18px 0 18px 20px', tablet: '18px 0 18px 24px' }}
      _hover={EMPTY_OBJECT}
      _active={{ '& [data-reacts-to-menu-group]': { transform: 'rotate(-180deg)' } }}
      onClick={e => e.stopPropagation()}
      rightIcon={
        <NextImage
          data-reacts-to-menu-group
          src={DownAngle}
          alt="Иконка стрелочки"
          w="18px"
          h="18px"
          transition={DEFAULT_TRANSITION}
        />
      }
    >
      <NextImage
        src={masks[activeMask].icon}
        alt={masks[activeMask].iconAlt}
        w={{ mobile: '22px', laptop: '28px' }}
        h={{ mobile: '16px', laptop: '20px' }}
      />
    </MenuButton>

    <MenuList
      data-lenis-prevent
      maxH="440px"
      w="full"
      minW="unset"
      p="0"
      cursor="pointer"
      alignItems="start"
      bgColor="ourWhite"
      borderRadius="18px"
      boxShadow="0px 2px 6px 2px rgba(3, 18, 35, 0.05), 0px 1px 20px 0px rgba(3, 18, 35, 0.06)"
      overflow="hidden"
      position="relative"
      overscrollBehavior="contain"
      zIndex="9999"
    >
      {masks.map(({ shortMask, icon, iconAlt, country }, i) => (
        <MenuItem
          key={i}
          bgColor="ourWhite"
          textStyle="b4"
          p={{ mobile: '9px 20px', tablet: '7px 24px' }}
          transition={DEFAULT_TRANSITION}
          _hover={{ bgColor: '#FFF6DB' }}
          onClick={() => onMaskChange(i)}
        >
          <NextImage
            src={icon}
            alt={iconAlt}
            w={{ mobile: '22px', laptop: '28px' }}
            h={{ mobile: '16px', laptop: '20px' }}
          />

          <InterText textStyle="b4" fontWeight="400" color="ourBlack" ml="8px">
            {country}{' '}
            <Text as="span" color="#757575">
              {shortMask}
            </Text>
          </InterText>
        </MenuItem>
      ))}
    </MenuList>
  </Menu>
);

export default memo(CountrySelector);
